import React, { Component } from 'react';
import moment from 'moment';

import { defaultSorter, dateSorter } from './Helpers';
import UserModel from './UserModel'

import { Table, Tooltip, Row, Col, Statistic } from 'antd';

class UrbioticaTechMessagesTable extends Component {

  state = {
    children: []
  }

  columns = [{
    title: 'ElementID',
    dataIndex: 'elementid',
    key: 'elementid',
    width: 30,
  }, {
    title: 'Veličina',
    dataIndex: 'phenomenonid',
    key: 'phenomenonid',
    width: 150,
    filters: [{
        text: 'temperature',
        value: 'temperature',
      }, {
        text: 'node_battery',
        value: 'node_battery',
      }],
      onFilter: (value, record) => record.phenomenonid === value,
  }, {
    title: 'Hodnota',
    dataIndex: 'measures',
    key: 'measures',
    width: 50,
    render: (text, record) => {
        if (record.unit == "C") {
            return record.measures + " °"+ record.unit
        } else {
            return record.measures + " "+ record.unit
        }
      }
  }, {
    title: 'Časová značka',
    dataIndex: 'stamps',
    key: 'stamps',
    width: 200,
    defaultSortOrder: 'descend',
    sorter: (a, b) => dateSorter(a.stamps, b.stamps),
    render: (text, record) => {
      return moment(text).format('L LTS');
    }
  }]

  render() {
    return (
      <Table
        size='small'
        rowKey={this.props.rowKey ? this.props.rowKey : '_id'}
        loading={this.props.loading ? this.props.loading : false}
        columns={this.columns}
        dataSource={this.props.data}
        pagination={{
          showSizeChanger: true,
          defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
            ? parseInt(localStorage.getItem('table_pageSize'))
            : 10,
          onShowSizeChange: (current, size) => {
            localStorage.setItem('table_pageSize', size);
          }
        }}
        style={{ border: '0px' }} />
    );
  }
}

export default UrbioticaTechMessagesTable;


// WEBPACK FOOTER //
// ./src/components/UrbioticaTechMessagesTable.js